import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Admin from "apis/Admin";

// First, create the thunk
export const partnerRequest = createAsyncThunk("partner", async (args) => {
  const [data, callback] = args;
  const response = await Admin.post("addPartner", data);
  console.log(response,"response login")
  callback();
  return response.data;
});

// Then, handle actions in your reducers:
const partnerSlice = createSlice({
  name: "addPartner",
  initialState: { message: "",  loading: false },
  reducers: { },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [partnerRequest.fulfilled]: (state, action) => {
      // Add key to the state array
      return { ...state, message: action.payload.message, loading: false };
    },
    [partnerRequest.pending]: (state) => {
      return { ...state, loading: true };
    },
    [partnerRequest.rejected]: (state, _action) => {
      return {
        ...state,
        message: "Failed",
        loading: false,
      };
    },
  },
});



export default partnerSlice.reducer;
